<template>
  <div class="dk-integ-page">
    <!-- ── Header ── -->
    <div class="dk-integ-header">
      <div class="dk-integ-header__left">
        <div class="dk-integ-header__icon-wrap">
          <feather-icon icon="Share2Icon" size="20" />
        </div>
        <div>
          <h2 class="dk-integ-header__title">Integrações</h2>
          <p class="dk-integ-header__sub">Conecte webhooks e plataformas para automatizar seus fluxos</p>
        </div>
      </div>
    </div>

    <Integration />
  </div>
</template>

<script>
import Integration from '@/views/App/Integracoes/Index.vue'

export default {
  name: 'IntegracaoPage',
  components: { Integration },
}
</script>

<style lang="scss" scoped>
$dk-navy: #0D3349;
$dk-orange: #E86A10;
$dk-gold: #F5B935;

.dk-integ-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px 0 24px;
}

.dk-integ-header {
  display: flex;
  align-items: center;
  padding: 18px 22px;
  background: var(--dk-bg-card, #fff);
  border-radius: 14px;
  border: 1px solid var(--dk-border, #edf1f4);
  box-shadow: 0 1px 4px rgba($dk-navy, 0.05);
}
.dk-integ-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.dk-integ-header__icon-wrap {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba($dk-orange, 0.12), rgba($dk-gold, 0.08));
  border: 1px solid rgba($dk-orange, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: $dk-orange;
  flex-shrink: 0;
}
.dk-integ-header__title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--dk-text-primary, $dk-navy);
  margin: 0 0 2px;
  line-height: 1.2;
}
.dk-integ-header__sub {
  font-size: 0.78rem;
  color: var(--dk-text-muted, #9ca5b0);
  margin: 0;
}
</style>
